import {fromJS} from 'immutable'
import {
  CLOSE_HINT,
  SHOW_HINT,
  TOGGLE_HINT,
} from '../constants/actionTypes'
import {
  TYPE_HINT_ERROR,
  TYPE_HINT_HELP,
} from '../constants/types'

const initialState = fromJS({
  hints: [
    {
      type: TYPE_HINT_HELP,
      visible: false,

    },
    {
      type: TYPE_HINT_ERROR,
      visible: false,
    },
  ]
});

const toggleHint = (state, {type}) => {
  const hints = state.toJS().hints;
  const hint = hints.find(hint => hint.type === type);
  hint.visible = !hint.visible;

  return fromJS({
    hints
  });
};

const closeHint = (state, {type}) => {
  const hints = state.toJS().hints;
  hints.find(hint => hint.type === type).visible = false;

  return fromJS({
    hints
  });
};

const showHint = (state, {type}) => {
  const hints = state.toJS().hints;
  hints.find(hint => hint.type === type).visible = true;

  return fromJS({
    hints
  });
};

export default function hints(state = initialState, action) {
  switch (action.type) {
    case TOGGLE_HINT:
      return toggleHint(state, action.payload);
    case CLOSE_HINT:
      return closeHint(state, action.payload);
    case SHOW_HINT:
      return showHint(state, action.payload);
    default:
      return state
  }
}